var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 16v7a7.008 7.008 0 0 1-7 7H2V16h6.465l3.577-5.366.845-5.917A2.01 2.01 0 0 1 14.867 3H17a3.003 3.003 0 0 1 3 3v6h6a4.004 4.004 0 0 1 4 4z",
    fill: "#2D809A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 32h32V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    d: "M7 29h1V17H7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedThumbsUp);
export default __webpack_public_path__ + "static/media/selected_thumbs_up.deb1112652d485834325ee798b8ff43f.svg";
export { ForwardRef as ReactComponent };